<div>
  <rask-list #hssearchresult
    [rowSelectable]="true"
    [data]="handelssortiment"
    id="handelssortimentSokResultat"
    [virtualScroll]="true"
    virtualScrollType="window"
    [useClientFilter]="true"
    clientFilterResultText="Handelssortiment"
    [virtualScrollItemHeight]="36"
    (checkedChanged)="onCheckedChange()"
    [fixedHeader]="true">
    <rask-list-column-checkbox></rask-list-column-checkbox>
    <rask-list-column header="{{ 'HANDELSSORTIMENT_LIST_NAMN' | translate }}" field="namn" [sortable]="true">
      <ng-template let-row="row">
        <a [routerLink]="[row.id]">
          {{row.namn}}
        </a>
        <a [routerLink]="[row.id]"
          target="_blank">
          <i class="far fa-sm fa-external-link p-r-half"></i>
        </a>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="{{ 'HANDELSSORTIMENT_LIST_BETECKNING' | translate }}" field="beteckning"
    [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'HANDELSSORTIMENT_LIST_SORTIMENTKOD' | translate }}" field="sortiment"
    [sortable]="true" [nowrap]="true" [tooltip]="true"></rask-list-column>
    <rask-list-column header="{{ 'HANDELSSORTIMENT_LIST_VIOLID' | translate }}" field="violid" [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'HANDELSSORTIMENT_LIST_HANDELSSORTIMENTSGRUPP' | translate }}"
    field="handelssortimentsgrupp" [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'HANDELSSORTIMENT_LIST_PRODUKTER' | translate }}" field="produkter"
    [sortable]="true" [nowrap]="true" [tooltip]="true"></rask-list-column>
    <rask-list-column header="{{ 'DEFAULT_GILTIG_FROM' | translate }}" field="giltighetFrom"
    [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'DEFAULT_GILTIG_TOM' | translate }}" field="giltighetTom"
    [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'HANDELSSORTIMENT_LIST_FORPRODUKTION' | translate }}" field="forProduktion"
    >
    <ng-template let-value>
        @if (value) {
        <i class="far fa-check"></i>
        }
    </ng-template>
    </rask-list-column>

    <rask-list-column header="{{ 'HANDELSSORTIMENT_LIST_FORINMATNING' | translate }}" field="forInmatning">
    <ng-template let-value>
        @if (value) {
        <i class="far fa-check"></i>
        }
    </ng-template>
    </rask-list-column>
    <rask-list-column header="{{ 'HANDELSSORTIMENT_LIST_AKTIV' | translate }}" field="aktiv">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
  </rask-list>
</div>